import React from 'react';
import {Reveal} from '../ui/Reveal';
import SafeIcon from '../common/SafeIcon';

const features=[ 
  "MAI Designated Appraisers for highest credibility.",
  "Data-driven, defensible valuation reports.",
  "Fast turnaround times to meet critical deadlines.",
  "Trusted by major regional and national banks.",
  "Reliable advisors for investors and attorneys.",
  "Court-tested litigation support and expert testimony." 
];

const WhyUs=()=> {
  return ( 
    <section id="about" className="bg-charcoal-950 py-24 border-b border-white/5"> 
      <div className="container mx-auto px-6 md:px-12"> 
        <div className="grid lg:grid-cols-2 gap-16 items-center"> 
          
          {/* Left Side: Large Logo Graphic */} 
          <Reveal direction="right"> 
            <div className="flex justify-center lg:justify-end"> 
              <div className="relative w-64 h-64 md:w-96 md:h-96 flex items-center justify-center"> 
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/d334477e75b4fabb65d5be5423d2041faad258e6d76e6691f8155cb326e304c728474a3a46f4e57b3b2d456fd1aa0681/images/aW1hZ2UvanBlZw==/8828e18fef6fb00dc96be6d038a45d2a.jpg" 
                  alt="Atlantic Real Estate Solutions Logo" 
                  className="max-w-full max-h-full object-contain rounded-xl shadow-2xl shadow-black/40"
                />
              </div> 
            </div> 
          </Reveal> 
          
          {/* Right Side: List */} 
          <Reveal direction="left"> 
            <div> 
              <h3 className="text-gold-500 text-2xl font-bold mb-2">Defensible Data. Proven Expertise.</h3> 
              <h2 className="text-white text-xl mb-8">Why Choose Atlantic Real Estate Solutions</h2> 
              <ul className="space-y-6"> 
                {features.map((feature,i)=> ( 
                  <li key={i} className="flex items-start gap-4"> 
                    <div className="mt-1 flex-shrink-0"> 
                      <SafeIcon name="Check" className="text-gold-500 bg-transparent" size={20} /> 
                    </div> 
                    <span className="text-gray-300 text-base leading-relaxed">{feature}</span> 
                  </li> 
                ))} 
              </ul> 
            </div> 
          </Reveal> 
          
        </div> 
      </div> 
    </section> 
  );
};

export default WhyUs;